import React from 'react'
import { Icon } from 'semantic-ui-react'

import EmptyState from 'shared/components/EmptyState'

const fillStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
}

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {import("react").CSSProperties=} props.style
 * @param {boolean=} props.hasTimeoutError
 * @param {boolean=} props.fill
 */
export const NoData = ({ className, style, hasTimeoutError = false, fill = true }) => {
  const text = hasTimeoutError
    ? 'This widget can’t load the results because the dataset is too large. Try narrowing your date range or applying filters.'
    : 'No data to display here yet.'

  return (
    <EmptyState
      className={className}
      style={fill ? { ...fillStyle, ...style } : style}
      icon={<Icon name="inbox" />}
    >
      {text}
    </EmptyState>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/NoData.js